import CODE128 from "./CODE128";
import autoSelectModes from "./auto";
class CODE128AUTO extends CODE128 {
  constructor(data, options) {
    if (/^[\x00-\x7F\xC8-\xD3]+$/.test(data)) {
      super(autoSelectModes(data), options);
    } else {
      super(data, options);
    }
  }
}
var stdin_default = CODE128AUTO;
export {
  stdin_default as default
};
